export default __webpack_public_path__ + "media/images/field-2-903129fadee5dc17744cb76823674077.png";